<ui-table
  *ngIf="data && data.length"
  [data]="data"
  [isWrapped]="false"
  [tblColor]="true"
  [tblRoundBottom]="true"
  (requestUpdate)="outputPaginationData($event)"
  [totalRecords]="totalRecords"
  [numberOfRows]="numberOfRows"
  [displayFilter]="['profileId', 'doctor', 'updDate']"
  [templates]="[
    {
      title: 'translate.general.activeSw',
      colClass: 'l-ta-center ui-p-5',
      template: activeSw,
      permission: true
    },
    {
      colClass: 'cell-50',
      template: edit,
      permission: true
    }
  ]"
></ui-table>

<ng-template #edit let-row="row">
  <button
    class="btn-editUser"
    [tooltip]="'translate.general.edit' | translate"
    (click)="editRow(row)"
  ></button>
</ng-template>

<ng-template #activeSw let-row="row">
  <i
    class="fas"
    [class.fa-check]="row.activeSw"
    [class.c-success]="row.activeSw"
    [class.fa-times]="!row.activeSw"
    [class.c-warn]="!row.activeSw"
  ></i>
</ng-template>
